import api from "@/plugins/axios";
import Site from "@/models/site";
import { Meta, QueryParams } from "@/models/general";

const SitesAPI = {
  async newSite(payload: Site): Promise<Site | undefined> {
    return api.post("/sites", payload);
  },
  async getSites(params: QueryParams): Promise<{ data: Site[]; meta: Meta }> {
    return api.get("/sites", {
      params: params,
    });
  },
  async deleteSite(id: string): Promise<void> {
    return api.delete(`/sites/${id}`);
  },
  async getSite(id: string): Promise<Site> {
    return api.get(`/sites/${id}`);
  },
  async updateSite(payload: Site): Promise<Site> {
    return api.put(`/sites/${payload.id}`, payload);
  },
};

export default SitesAPI;
